import { useMaybeSuspenseIndexQuery } from 'api';
import { useCurrentRole, useIsCurrentUserAdmin } from 'hooks/slices';
import type { FC } from 'react';
import { EnvironmentWatermark } from 'utils/environmentIndicator';
import { NavbarBase } from './NavbarBase';
import { FaksAdminNavSection } from './resourceNavSections/FaksAdminNavSection';
import { GroupNavSection } from './resourceNavSections/GroupNavSection';
import { LabNavSection } from './resourceNavSections/LabNavSection';
import { PharmacyNavSection } from './resourceNavSections/PharmacyNavSection';

type Props = {
  isOpenSidebar: boolean;
  onCloseSidebar: VoidFunction;
};

const Navbar: FC<Props> = ({ isOpenSidebar, onCloseSidebar }) => {
  const isCurrentUserAdmin = useIsCurrentUserAdmin();
  const currentRole = useCurrentRole();

  const isPharmacy = currentRole?.resource_type === 'Pharmacy';
  const isLab = currentRole?.resource_type === 'Lab';
  const isGroup = currentRole?.resource_type === 'Group';

  const myGroupQuery = useMaybeSuspenseIndexQuery(
    'pharmacies/my_group',
    {},
    { enabled: isPharmacy }
  );

  return (
    <NavbarBase
      isOpenSidebar={isOpenSidebar}
      onCloseSidebar={onCloseSidebar}
      appTheme={myGroupQuery.data?.group?.app_theme || undefined}
    >
      <EnvironmentWatermark />

      {isCurrentUserAdmin && <FaksAdminNavSection />}
      {isLab && <LabNavSection />}
      {isPharmacy && <PharmacyNavSection />}
      {isGroup && <GroupNavSection />}
    </NavbarBase>
  );
};

export default Navbar;
